// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

// if (process.env.ENVIRONMENT === 'production') {
Sentry.init({
  dsn:
    SENTRY_DSN ||
    'https://08976c5f4c7083b98a0a3b0be8808978@o147211.ingest.us.sentry.io/4506980505354240',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,
  environment: process.env.ENVIRONMENT,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  ignoreErrors: [
    'The email address is badly formatted.',
    'The password is invalid or the user does not have a password.',
    /routeChange aborted/,
  ],
});
// }
